// @flow
import type { ChildrenArray, Element } from 'react';
import React from 'react';
import {
  types as t,
  usePropsValidation,
} from '../../validation/runtime-checks/index.js';
import Latex from '../../Latex.js';
import { illustrationColor } from '../../designSystem.js';
import { LatexTextAtom } from '../../LatexTextAtom.js';

export function RSLGlossaryTerm(props: {|
  children: ChildrenArray<
    string | Element<typeof Latex> | Element<typeof LatexTextAtom>,
  >,
|}) {
  const { failedValidation } = usePropsValidation(props, RSLGlossaryTerm);
  if (failedValidation) return null;
  return (
    <strong style={{ fontWeight: 600, color: illustrationColor.cloudburst }}>
      {props.children}
    </strong>
  );
}
RSLGlossaryTerm.spec = {
  children: t.childrenArray(
    t.unionOfTypes(
      t.string,
      t.elementType(Latex),
      t.elementType(LatexTextAtom),
    ),
  ),
};
